import React, { useContext } from 'react';

import {
  SET_ACTIVE_SCREEN,
  SET_PROGRESS,
  INCREASE_PROGRESS,
  RESET_APP,
  START_OVER,
} from './app-actions';

function appReducer(state, action) {
  switch (action.type) {
    case SET_ACTIVE_SCREEN: {
      return { ...state, screen: action.payload };
    }

    case SET_PROGRESS: {
      return { ...state, progress: action.payload > 1 ? 1 : action.payload };
    }

    case INCREASE_PROGRESS: {
      const progress = state.progress + action.payload;
      return { ...state, progress: progress > 1 ? 1 : progress };
    }

    case START_OVER: {
      return {
        ...state,
        screen: 1,
        progress: 0,
      };
    }

    case RESET_APP: {
      return {
        ...state,
        screen: 0,
        progress: 0,
      };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// create context

const AppContext = React.createContext();
AppContext.displayName = 'AppContext';

// hook
export const useAppContext = () => useContext(AppContext);

export { AppContext, appReducer };
